import { BasicsClass } from '@/common/BasicsClass';
export class DataStatisticRecordAPI extends BasicsClass {
    public apiUrls: any = new Map([
        ['getDataTotalRecords', {
            url: '/admin/data_board/analysis',
            name: 'data-board-business-echats',
            label: '营业图表数据'
        }],
        ['getProvinceInfo', {
            url: '/admin/data_board/analysisProvince',
            name: 'data-board-business-province-info',
            label: '地图省份营业详情'
        }],
        ['getChannelRadioRecord', {
            url: '/admin/data_board/analysisChannelRatio',
            name: 'data-board-business-channel-radio',
            label: '营业数据渠道占比'
        }]
       
    ])

    // 营业图标数据
    public getDataTotalRecords(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls

        const url = apiUrls.get('getDataTotalRecords').url

        this.BasicPost(url, {
            ...params
        }, false, false, false, successCb, failCb, showLoading)
    }

    // 地图省份营业详情
    public getProvinceInfo(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls

        const url = apiUrls.get('getProvinceInfo').url

        this.BasicPost(url, {
            ...params
        }, false, false, false, successCb, failCb, showLoading)
    }

    // 营业数据渠道占比
    public getChannelRadioRecord(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls

        const url = apiUrls.get('getChannelRadioRecord').url

        this.BasicPost(url, {
            ...params
        }, false, false, false, successCb, failCb, showLoading)
    }

}